/* src/app/shop/productos/product-part-info-interaction/product-part-info-interaction.component.scss */
h1 {
  font-family: "League Spartan", sans-serif;
  font-size: 28px;
  font-weight: 600;
  margin-top: 5px;
  color: black !important;
}
h1.isSummary {
  margin-top: 25px;
}
.qty-text {
  font-family: "League Spartan", sans-serif;
  font-weight: 300;
  font-size: 18px;
  color: black !important;
}
.oldPrice {
  font-family: "League Spartan", sans-serif;
  font-weight: 500;
  font-size: 18px;
  text-decoration: line-through;
  color: var(--ion-color-tertiary);
}
.price {
  font-family: "League Spartan", sans-serif;
  font-weight: 400;
  font-size: 34px;
  color: black !important;
}
.price-custom {
  font-family: "League Spartan", sans-serif;
  font-weight: 600;
  font-size: 22px;
  color: #43c0f6 !important;
}
ion-button {
  font-family: "League Spartan", sans-serif !important;
  font-size: 18px;
  font-weight: 500;
  --border-radius: 6px;
  height: fit-content;
}
ion-button::part(native) {
  padding: 8px 15px 10px 15px;
}
ion-button ion-icon {
  margin-right: 5px;
  font-size: 20px;
  filter: invert(1);
}
ion-button .inner-button-add-to-cart {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
}
.custom-button {
  font-family: "League Spartan", sans-serif !important;
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  color: white;
  --border-radius: 10px;
  --background: black;
  --background-hover: rgb(37, 37, 37);
  --background-activated: rgb(56, 56, 56);
  --box-shadow: 0 2px 10px 0 rgb(0, 0, 0, 0.5);
  min-height: 0;
}
.custom-button::part(native) {
  padding: 12px 16px 12px 16px;
}
.custom-button ion-icon {
  margin-right: 5px;
  font-size: 24px;
  filter: invert(1);
}
.inner-button {
  display: flex;
  flex-direction: row;
}
@media (max-width: 400px) {
  .custom-button {
    min-height: 1 !important;
  }
  .inner-button {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
}
.configuration-options-container {
  box-sizing: border-box;
  padding: 10px;
  padding-left: 15px;
  padding-right: 15px;
  border-radius: 15px 15px 0 0;
  gap: 20px;
  margin-bottom: 0 !important;
  background-color: #f6f6f6;
  overflow-y: scroll;
}
.cantidad-precio-container {
  background-color: #e6e6e6;
  border-radius: 0 0 15px 15px;
  padding: 20px;
  width: 100%;
}
.radius {
  background-color: #e6e6e6;
  border-radius: 15px;
  padding: 20px;
  width: 100%;
}
@media only screen and (max-width: 1104px) {
  .cantidad-precio-container {
    padding: 15px;
  }
  .cantidad-precio-container .custom-button {
    font-weight: 500;
    font-size: 18px;
  }
  .price {
    font-size: 18px;
  }
}
@media only screen and (max-width: 997px) {
  .cantidad-precio-container {
    padding: 15px;
  }
  .cantidad-precio-container .custom-button {
    font-weight: 500;
    font-size: 18px;
  }
  .price {
    font-size: 18px;
  }
}
@media only screen and (max-width: 400px) {
  .custom-button {
    width: 100% !important;
    font-weight: 500;
    font-size: 18px;
  }
}
.no-variation-message {
  font-family: Barlow Semi Condensed;
  font-size: clamp(1.125rem, 1.0714rem + 0.2597vw, 1.25rem);
  font-weight: 500;
  line-height: 24px;
  background-color: white;
  padding: 10px;
  border-radius: 15px;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.3019607843);
}
/*# sourceMappingURL=product-part-info-interaction.component-2TOYTI5L.css.map */
